// extracted by mini-css-extract-plugin
module.exports = {"empty_tab":"styles_empty_tab__3uDnH","empty_container":"styles_empty_container__1u7D-","empty_header":"styles_empty_header__11yqc","empty_content":"styles_empty_content__16pUa"};